import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import React from "react";
import { SignatureImageImproved } from "../../utils/SignatureImage";
const tick_char = "✓";

// const weatherConditionsFormatter = (values) => {
//   let result = "";
//   if (values) {
//     result = (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           // alignItems: "center",
//           gap: "12px",
//           padding: "8px ",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             gap: "80px",
//             // justifyContent: "center",
//           }}
//         >
//           <TickBox label="Night" flag={values[0] === true} />
//           <TickBox label="Day" flag={values[1] === true} />
//           <TickBox label="Foggy" flag={values[2] === true} />
//         </div>

//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             gap: "80px",
//             // justifyContent: "center",
//           }}
//         >
//           <TickBox label="Hot" flag={values[3] === true} />
//           <TickBox label="Cold" flag={values[4] === true} />
//           <TickBox label="Clear" flag={values[5] === true} />
//         </div>
//       </div>
//     );
//   }
//   return result;
// };
const weatherConditionsFormatter = (values) => {
  let result = "";
  if (values) {
    result = (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px 80px",
          padding: "0px",
          marginTop: "-25px",
          // justifyItems: "center",
        }}
      >
        <TickBox label="Night" flag={values[0] === true} />
        <TickBox label="Day" flag={values[1] === true} />
        <TickBox label="Foggy" flag={values[2] === true} />
        <TickBox label="Hot" flag={values[3] === true} />
        <TickBox label="Cold" flag={values[4] === true} />
        <TickBox label="Clear" flag={values[5] === true} />
      </div>
    );
  }
  return result;
};

export const InspectionReportHeader = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Track Inspected",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Location of Inspection",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Weather Conditions",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "Track 2 (Eastbound)",
        colSpan: 2,
        rowSpan: 2,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: ["trackNumber", "trackDirection"],
        dontJoinValues: true,
        formatter: (values) => {
          if (!values || values.length === 0) return "";

          if (values[1] === null || values[1] === undefined || values[1] === "") {
            return values[0];
          }

          return `${values[0]} (${values[1]})`;
        },

        //  bindingAccessor: "trackdir",
      },
      {
        title: " Start:",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,

        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: " ",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        isValueOnly: true,
        accessor: "start",
      },

      {
        title: " Day: ",
        colSpan: 2,
        rowSpan: 2,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: ["night", "day", "fog", "hot", "cold", "clear"],
        dontJoinValues: true,

        formatter: weatherConditionsFormatter,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,

    columns: [
      {
        title: " End:",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,

        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Barrio Logan (Air Gap)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "end",
      },
    ],
  },
];

export const InspectionsReportSchema = [
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Part/Assembly Inspected",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Example of what to Look for",
        colSpan: 3,
        rowSpan: 5,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Result Code",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Comments",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Dropper Assemblies",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Tight, non‐damaged, No missing parts.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "dropper",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com50",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Knife Switches",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Free of visual damage, no arc splatter on stabs",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "knife",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com54",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: " Feeder Cables",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Cables Banded, Not just zip tied. All clamps free of damage.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "feeder",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com58",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: " Equilizers",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Should be found ~every other OCS pole. Damaged wire/clamps",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "equilizers",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com62",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: " J‐hooks",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Check for signs of burning / arcing.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "hooks",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com66",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Contact Wire",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Arc splatter, Rolling, Thin Spots ",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "contact",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com70",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Messenger Wire",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "No broken strands (possibly at locations with hanger droppers) ",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "messenger",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com74",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Sleds / Section Insulators /  Air Gaps",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Arc horn condition, arc splatter, Thin contact wire, supports tight. ",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "sleds",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com78",
      },
    ],
  },

  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Insulation (Johnny Ball / Stick)",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Uncracked, signs of bleed‐over, Stick insulators fraying, twisted.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "insulation",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com82",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Head Span / Support Spans",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Arcing or corrosion / hardware tight /Insulation undamaged. ",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "span",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com86",
      },
    ],
  },

  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Lightning Arrestors",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Not blown, uncut ground wire, clamps undamaged and tight.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "lightning",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com90",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Bridge Assemblies",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Undamaged clamps, thinning spots where wires overlap",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "bridge",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com94",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Obstructions (Trees / Vegetation)",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Vegetation within or near OCS or express cable ect.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "obstructions",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com98",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Cantilever / Arm Assembly",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Associated clamps / hardware / Insulation undamaged.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "cantilever",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com102",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: " Down Guys",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Undamaged wire / down guy cover / associated hardware.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "down",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com106",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "OCS poles",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Pole covers not missing.",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "it2j",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com110",
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: " Other",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        // leftAlign: true,
        accessor: "other",
      },
      {
        title: " ",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        unBold: true,
        className: "tbl-text-normal",
        isValueOnly: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "it3a",
      },
      {
        title: "",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "com122",
      },
    ],
  },
];

export const SystemInspectionReport = {
  heights: {
    header1: "40px",
  },
  classes: {
    header2: "",
  },
  inlineData: false,
  minDataRowsCount: 3,
  columns: [
    {
      title: "Description of Defect",
      colSpan: 3,
      rowSpan: 1,
      accessor: "desc",
    },

    {
      title: "Location of Defect",
      colSpan: 3,
      rowSpan: 1,
      accessor: "loc",
    },

    {
      title: "Requires further action",
      colSpan: 3,
      rowSpan: 1,
      accessor: "requiress",
    },
    {
      title: "Parts Used:",
      colSpan: 3,
      rowSpan: 1,
      accessor: "partsUsed",
    },
  ],
};
export const SystemInspectionComment = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "COMMENTS",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Comments:",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "coms",
      },
    ],
  },
];
export const SystemInspectionInfo = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "MAINTAINERS NAME",
        colSpan: 2,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        accessor: "mainName",
        leftAlign: true,
      },
      {
        title: "EMPLOYEE NUMBERS",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        accessor: "empName",
        leftAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "TIME IN MAN HOURS",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isValueOnly:true,
        accessor: "timeManhrs",
        leftAlign: true,
      },
      {
        title: "SUPERVISOR SIGNATURE",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isValueOnly:true,
        formatter: (id) => {
          return <SignatureImageImproved width={"30%"} signatureImage={id} />;
        },
        accessor: "sign2",
        leftAlign: true,
      },
      {
        title: "Date Reviewed",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isValueOnly:true,

        accessor: "date2",
        leftAlign: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/SDMTS/InspectionReportForm/InspectionReportSchema.jsx